/*
 ************************************************************************
 *  © [2015 - 2023] Quintype Technologies India Private Limited
 *  All Rights Reserved.
 *************************************************************************
 */

export const USER_PATH = "/user";
export const USER_PROFILE_PATH = `${USER_PATH}/profile`;
